module.exports = __webpack_public_path__ + "static/Jammming-6ba23ea88a13ab91af82bef3e7dae944.png";